import "./SearchResult.scss";

import { ReplacementKind } from "shared/src/tracking/Tracking";

import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import process from "process";
import Tracking from "shared/src/uidispatcherapi/Tracking";
import { Clearfix, Col, Row, Well } from "react-bootstrap";
import { getParam, setParam } from "../../../../utils/RouterUtil";

import SearchResultPageContent from "./SearchResultPageContent";

import SearchPageHeader from "../../search/SearchPageHeader";
import ContentSearchResultHeader from "../../search/ContentSearchResultHeader";
import ContentSearchResult from "../../search/ContentSearchResult";
import SearchFilterPanel from "../filters/SearchFilterPanel";
import LoadingPanel from "../../../general/LoadingPanel";
import FilterPanelShowButton from "../filters/FilterPanelShowButton";
import Suggestion from "./Suggestion";
import { connect } from "shared/src/stores/storeConnect";
import * as SearchUtil from "../../../../utils/SearchUtil";
import { trackChangeSearchContentTab, trackNextPage } from "../../../../utils/SearchTrackingUtil";
import { SearchQuery, SearchResultEx, SearchResultState } from "shared/src/types/articlesearch/SearchResult";
import { PageType } from "shared/src/types/PageType";
import { isFixedContentWidth } from "../../../../searchdiscover/toggles";
import { FixedWidthWrapper } from "../../../general/FixedWidthWrapper";
import SearchResultStore from "../../../../stores/SearchResultStore";
import ContentSearchStore from "../../../../stores/ContentSearchStore";
import SessionStore, { CustomerTierLevel, getCustomerTierEnum } from "shared/src/stores/SessionStore";
import { Trigger as CreateSearchResultFeedbackModalTrigger } from "./SearchResultFeedbackModal";
import { SubCategoryPanel } from "../../categories/SubCategoryPanel";
import { drillDownToCategoryForSubcategoryPanels } from "../../../../utils/categoryUtils";
import { CategoryHeaderBreadcrumbs, SearchHeaderBreadcrumbs } from "../filters/CategoryNavigation";
import { ZeroSearchResult } from "../../search/zeroresults/ZeroSearchResult";
import CountryUtil from "shared/src/uidispatcherapi/CountryUtil";
import { getComponentByName } from "shared/src/components/LazyWrapper";
import { deepEqual } from "shared/src/utils/util";
const SideCaddy = getComponentByName("oc_ui/SideCaddy");

const LOADING_MESSAGE_ID = "EX_SEARCHING";

type TrackingHeadline =
    | {
          type: "text";
          text: string;
      }
    | {
          type: "key";
          key: string;
      };

type HeaderType = "filter-only" | null | void;

type SubcategoryPanelConfig = {
    show: boolean;
    lines: number;
};

type SearchResultProps = {
    location?: {
        [x: string]: any;
    };
    query: SearchQuery;
    excludedFacets?: Set<string> | null;
    fullPageBanner?: React.ReactNode | null;
    subcategoryPanelConfig?: SubcategoryPanelConfig | null;
    articleTeaserBanner: React.ReactNode | any | undefined | null; // ToDO migrate flow to typescript
    pageClass: string;
    replace?: {
        [x: string]: any;
    };
    listOfArticles: Array<any>;
    customerStore: string;
    searchResult: SearchResultState | undefined | null;
    isEmployee: boolean;
    employeeId: string | null | undefined;
    customerId: string | null | undefined;
    customerTierLevel: CustomerTierLevel | null | undefined;
    loggedIn: boolean | null | undefined;
    headline:
        | {
              [x: string]: any;
          }
        | string
        | undefined
        | null;
    headerType: HeaderType;
    trackingHeadline: TrackingHeadline;
    doNotShowAllCategoriesLink?: boolean;
    queryLinkComponent: any;
    onChangeQuery: (query: SearchQuery) => void;
    pageType: PageType;
    pageName?: string;
    contentInfo?: {
        amount: number;
        loading: boolean;
    };
    replacementKind?: ReplacementKind;
};

class SearchResult extends React.Component<
    SearchResultProps,
    {
        panelOpen: boolean;
    }
> {
    static contextTypes = {
        router: PropTypes.object.isRequired,
        intl: PropTypes.object
    };

    constructor(props: SearchResultProps) {
        super(props);
        this.state = {
            panelOpen: false
        };
    }

    selectedTabIndex() {
        if (!this.props.location) {
            return 0;
        }
        return getParam("tab", this.props.location) !== "content" ? 0 : 1;
    }

    componentWillReceiveProps(newProps: SearchResultProps) {
        // close the panel when the search / filter changes
        if (!deepEqual(newProps.query, this.props.query)) {
            this.setState({
                panelOpen: false
            });
        }
        if (this.props.pageName && this.props.searchResult?.searchRunning && !newProps.searchResult?.searchRunning) {
            const pageTitle =
                newProps.trackingHeadline.type === "text"
                    ? newProps.trackingHeadline.text
                    : this.context.intl.formatMessage({
                          id: newProps.trackingHeadline.key
                      });
            if (this.props.pageType === "CATEGORY") {
                const path = (this.props.query.categoryPath || "").split("/");
                Tracking.trackPageImpression(pageTitle, this.props.pageName, path);
            } else {
                Tracking.trackPageImpression(pageTitle, this.props.pageName);
            }
        }
    }

    handleTogglePanel() {
        this.setState({
            panelOpen: !this.state.panelOpen
        });
    }

    loadmore = (e: React.SyntheticEvent) => {
        e.preventDefault();
        const pageNumber = this.context.router.location?.state?.numPagesSearch ?? 1;
        trackNextPage(this.props.pageType, pageNumber + 1);
        SearchUtil.updatePaginationState("numPagesSearch", this.context.router);
    };

    handleTabChange = (newTab: number) => {
        if (!this.props.location) {
            return;
        }
        setParam({ tab: newTab === 1 ? "content" : "search" }, this.context.router, this.props.location);
        trackChangeSearchContentTab(newTab === 0 ? "searchTab" : "contentTab");
    };

    renderNoSearchPanel() {
        const noSearch = (
            <Well className="ex-search-query-badge">
                <div className="ex-search-header">
                    <h1 className="no-result">
                        <FormattedMessage id="EX_SEARCHING_MISSING" />
                    </h1>
                </div>
            </Well>
        );
        if (process.env.NODE_ENV === "development") {
            try {
                const giphy = (
                    <Well className="ex-search-query-badge">
                        <div className="panel-body">
                            <div className="ex-search-header">
                                <h1 className="giphy">
                                    <img src="https://media1.giphy.com/media/l41lFw057lAJQMwg0/200.gif#1" />
                                </h1>
                            </div>
                        </div>
                    </Well>
                );
                return giphy;
            } catch (e) {
                return noSearch;
            }
        } else {
            return noSearch;
        }
    }

    showNoResultPage(results: SearchResultEx | null | undefined, valid: boolean, searchRunning: boolean) {
        const usedOrSearch = results && results.usedOrSearch;
        const hasAtLeastOneResult = results && results.amount > 0;
        const searchResultsNotSufficient = results && (!hasAtLeastOneResult || !valid || usedOrSearch);
        const searchFinishedButNoResult = !searchRunning && !results;
        return searchResultsNotSufficient || searchFinishedButNoResult;
    }

    renderArticleSearchResultContent() {
        const searchRunning = this.props.searchResult?.searchRunning ?? false;
        const loadingMore = this.props.searchResult?.loadingMore ?? false;

        const results: SearchResultEx | undefined | null = this.props.searchResult?.result;
        if (!results || (searchRunning && !loadingMore)) {
            return (
                <Col lg={9}>
                    <LoadingPanel messageId={LOADING_MESSAGE_ID} />
                </Col>
            );
        }

        const category = results.categorytree
            ? drillDownToCategoryForSubcategoryPanels(results.categorytree, this.props.query.categoryPath)
            : null;

        const banner = (
            <div>
                {this.props.fullPageBanner}
                {this.props.subcategoryPanelConfig?.show && category !== undefined && category !== null ? (
                    <SubCategoryPanel
                        category={category}
                        query={this.props.query}
                        lines={this.props.subcategoryPanelConfig?.lines}
                        queryLinkComponent={this.props.queryLinkComponent}
                    />
                ) : (
                    ""
                )}
            </div>
        );

        const showLoadMoreButton = SearchUtil.loadMoreButtonNeeded(results, searchRunning);
        return (
            <SearchResultPageContent
                query={this.props.searchResult?.q}
                fullPageBanner={banner}
                articleTeaserBanner={this.props.articleTeaserBanner}
                replace={this.props.replace}
                listOfArticles={this.props.listOfArticles}
                results={results}
                showLoadMoreButton={showLoadMoreButton}
                searchRunning={searchRunning}
                loadingMessageId={LOADING_MESSAGE_ID}
                customerStore={this.props.customerStore}
                loadMoreResultsHandler={this.loadmore}
                pageType={this.props.pageType}
                replacementKind={this.props.replacementKind}
            />
        );
    }

    renderContent(showNoResultPage: boolean) {
        switch (this.selectedTabIndex()) {
            case 1:
                return <ContentSearchResult />;
            default:
                const contentClass = this.props.pageClass || "body";
                const results = this.props.searchResult?.result;
                const filterPanel = (
                    <SearchFilterPanel
                        query={this.props.query}
                        categories={results ? results.categorytree : undefined}
                        facets={results ? results.allFacets : []}
                        excludedFacets={this.props.excludedFacets || new Set()}
                        doNotShowAllCategoriesLink={this.props.doNotShowAllCategoriesLink}
                        queryLinkComponent={this.props.queryLinkComponent}
                        onChangeQuery={this.props.onChangeQuery}
                    />
                );
                // TODO(DaBi): Throw filterPanelShowButton out of this function again as soon as UI/UX has come up with
                //  a better approach towards handling filter options on the ZeroSearchResult page, especially with
                //  respect to unselecting enabled (default) filters having lead to/caused 0 search results
                //  (This is a quick-fix to https://jira.metrosystems.net/browse/SDCORP-530126)
                const filterPanelShowButton = (
                    <FilterPanelShowButton
                        onClick={this.handleTogglePanel.bind(this)}
                        panelOpen={this.state.panelOpen}
                    />
                );
                const pageContent = showNoResultPage ? (
                    <Row className={contentClass}>
                        <Col lg={3}>
                            <div className="big-screen-filter-panel mfcss_left-side-navigation">{filterPanel}</div>
                        </Col>
                        <Col lg={9}>
                            <ZeroSearchResult
                                searchResult={this.props.searchResult}
                                fullPageBanner={this.props.fullPageBanner}
                                filterPanelShowButton={filterPanelShowButton}
                            />
                        </Col>
                    </Row>
                ) : (
                    <Row className={contentClass}>
                        <Col lg={3}>
                            <div className="big-screen-filter-panel mfcss_left-side-navigation">{filterPanel}</div>
                        </Col>
                        {this.renderArticleSearchResultContent()}
                    </Row>
                );

                return <FixedWidthWrapper>{pageContent}</FixedWidthWrapper>;
        }
    }

    renderToolbarForSmallScreens() {
        return (
            <Clearfix className="mfcss_pageheader hidden-lg hidden-xl ex-searchpage-subheader">
                <FilterPanelShowButton onClick={() => this.handleTogglePanel()} panelOpen={this.state.panelOpen} />
            </Clearfix>
        );
    }

    renderHeader() {
        if (this.props.headerType === "filter-only") {
            return this.renderToolbarForSmallScreens();
        }
        switch (this.selectedTabIndex()) {
            case 1:
                return (
                    <ContentSearchResultHeader
                        onTabClick={(newTab) => this.handleTabChange(newTab)}
                        activeTab={this.selectedTabIndex()}
                    />
                );
            default:
                const results = this.props.searchResult?.result;
                const query = this.props.searchResult?.q ?? "";
                const headlineText = <span>{this.props.headline}&nbsp;</span>;
                let subHeadline = null;
                if (results) {
                    subHeadline = (
                        <Suggestion
                            query={{
                                original: query,
                                final: results.query,
                                suggestion: results.suggestion
                            }}
                            amount={{
                                final: results.amount,
                                suggestion: results.suggestionHits
                            }}
                        />
                    );
                }

                const sortKey = this.props.query ? this.props.query.sorting : null;
                const specifiedSortValue = SearchUtil.getSelectedSortCriteria(sortKey);
                const filterPanelShowButton = (
                    <FilterPanelShowButton
                        onClick={this.handleTogglePanel.bind(this)}
                        panelOpen={this.state.panelOpen}
                    />
                );

                const searchResultFeedbackButton = (
                    <CreateSearchResultFeedbackModalTrigger
                        searchFeedbackData={{
                            employeeId: this.props.employeeId,
                            selectedCustomerId: this.props.customerId ?? "",
                            resultIds: this.props.searchResult?.result?.resultIds,
                            numberOfSearchResults: this.props.searchResult?.result?.amount ?? 0
                        }}></CreateSearchResultFeedbackModalTrigger>
                );

                let headerBreadcrumbs = null;
                if (
                    this.props.query?.searchPurpose === "category" &&
                    CountryUtil.getOptionalConfig().showCategoryHeaderBreadcrumbs &&
                    this.props.searchResult?.result?.categorytree
                ) {
                    headerBreadcrumbs = (
                        <CategoryHeaderBreadcrumbs
                            categoryPath={this.props.query.categoryPath}
                            categories={this.props.searchResult?.result?.categorytree}
                            doNotShowAllCategoriesLink={false}
                            query={this.props.query}
                            queryLinkComponent={this.props.queryLinkComponent}
                        />
                    );
                } else if (
                    this.props.query?.searchPurpose === "search" &&
                    CountryUtil.getOptionalConfig().showSearchHeaderBreadcrumbs
                ) {
                    headerBreadcrumbs = <SearchHeaderBreadcrumbs query={this.props.query} />;
                }

                return (
                    <SearchPageHeader
                        onTabClick={(newTab) => this.handleTabChange(newTab)}
                        activeTab={this.selectedTabIndex()}
                        headline={headlineText}
                        subheadline={subHeadline}
                        headerBreadcrumbs={headerBreadcrumbs}
                        query={this.props.query}
                        pageType={this.props.pageType}
                        onChangeQuery={this.props.onChangeQuery}
                        specifiedSortValue={specifiedSortValue}
                        filterPanelShowButton={filterPanelShowButton}
                        searchResultFeedbackButton={searchResultFeedbackButton}
                        searchResult={this.props.searchResult}
                    />
                );
        }
    }

    render() {
        const searchRunning = !!this.props.searchResult?.searchRunning;
        const query = this.props.searchResult?.q;
        const results = this.props.searchResult?.result;
        const valid = !!this.props.searchResult?.valid;
        const showNoResultPage = this.showNoResultPage(results, valid, searchRunning);
        // Falsy state.
        if (!query && !searchRunning) {
            return this.renderNoSearchPanel();
        }
        const types = ["SEARCH", "OFFERS", "PROMOTION", "CATEGORY"];
        const shouldAddSideCaddy = !showNoResultPage && types.find((entry) => entry === this.props.pageType);
        const panelClass = "ex-filter-page-content " + (this.state.panelOpen ? "panel-open" : "panel-closed");
        const className = isFixedContentWidth() ? "" : "search-result-wrapper";
        return (
            <React.Fragment>
                <div className={panelClass}>
                    {this.renderHeader()}
                    <div className={className}>{this.renderContent(showNoResultPage)}</div>
                </div>
                {shouldAddSideCaddy ? <SideCaddy /> : null}
            </React.Fragment>
        );
    }
}

const wrapped = connect(
    {
        stores: [
            [
                SearchResultStore,
                (s: typeof SearchResultStore) => ({
                    searchResult: s.getState()
                })
            ],
            [
                SessionStore,
                (s: typeof SessionStore) => ({
                    customerStore: s.makeState().customerStore,
                    isEmployee: s.makeState().isEmployee,
                    employeeId: s.makeState().employeeId,
                    customerId: s.makeState().customerId,
                    customerTierLevel: getCustomerTierEnum(),
                    loggedIn: s.makeState().loggedIn
                })
            ],
            [
                ContentSearchStore,
                (s: typeof ContentSearchStore) => ({
                    contentInfo: {
                        amount: s.getState()?.numFound ?? 0,
                        loading: s.getState()?.loading ?? false
                    }
                })
            ]
        ]
    },
    SearchResult
);

export default wrapped;
